import styled from 'styled-components'
import { tokens } from 'styling/tokens'
import { fleetColors } from '../FleetOverview/FleetOverview.styled'

export { fleetColors }

export const ComingSoonWrapper = styled.div`
  position: relative;
  overflow: hidden;

  .cs-blur {
    filter: blur(4px);
    pointer-events: none;
    user-select: none;
  }

  .cs-label {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: ${tokens.text.primary};
    background: rgba(0, 0, 0, 0.18);
    border-radius: inherit;
  }
`

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
`

export const TitleBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  .back {
    background: transparent;
    border: none;
    cursor: pointer;
    color: ${tokens.text.primary};
    display: flex;
    align-items: center;
    padding: 4px;
    border-radius: 6px;

    &:hover {
      background: ${tokens.border.hairline};
    }
  }
`

export const TopRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`

export const RangeBtns = styled.div`
  display: flex;
  gap: 6px;
  margin-left: auto;
`

export const RangeBtn = styled.button<{ active?: boolean }>`
  background: ${({ active }) => (active ? tokens.accent.base : 'transparent')};
  color: ${({ active }) => (active ? tokens.accent.ink : tokens.text.primary)};
  border: 1px solid ${({ active }) => (active ? tokens.accent.base : tokens.border.hairline)};
  border-radius: ${tokens.radius.chip};
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
`

export const Grid4 = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;
`

export const Grid5 = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;
`

export const Split = styled.div<{ cols?: string }>`
  display: grid;
  grid-template-columns: ${(p) => p.cols || '1fr 1fr'};
  gap: 1rem;
  margin-bottom: 1rem;
`

export const Panel = styled.div<{ accent?: string }>`
  background: ${tokens.surface.glass};
  border: 1px solid ${(p) => p.accent || tokens.border.hairline};
  border-radius: ${tokens.radius.card};
  box-shadow: ${tokens.shadow.card};
  padding: 1.25rem;
  backdrop-filter: blur(${tokens.blur});
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const InfoPairGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem 1.5rem;
  margin-bottom: 1rem;

  .col-value {
    display: flex;
    align-items: center;
    gap: 6px;

    svg {
      color: ${tokens.accent.base};
      width: 16px;
      height: 16px;
    }
  }

  .telemetry {
    color: ${tokens.status.success.fg};
    font-weight: 600;
  }
`

export const FuelBar = styled.div`
  margin-top: 6px;
  height: 8px;
  background: ${tokens.surface.base};
  border-radius: 4px;
  overflow: hidden;
`

export const FuelFill = styled.div<{ width: number }>`
  width: ${(p) => p.width}%;
  height: 100%;
  background: ${tokens.accent.base};
`

export const StateGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
  margin-top: 0.75rem;
`

export const StateTile = styled.div`
  background: ${tokens.surface.base};
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  padding: 0.85rem 1rem;
`

export const RegTable = styled.div`
  .row {
    display: flex;
    justify-content: space-between;
    padding: 0.65rem 0;
    border-bottom: 1px solid ${tokens.border.hairline};
  }

  .row:last-child {
    border-bottom: none;
  }
`

export const ChartBox = styled.div`
  position: relative;
  height: 180px;
  padding-top: 0.5rem;
`

export const ChartBars = styled.div`
  position: absolute;
  inset: 0.5rem 0 1.5rem 0;
  display: flex;
  align-items: flex-end;
  gap: 4px;
`

export const Bar = styled.div<{ h: number; color: string; muted?: boolean }>`
  flex: 1;
  height: ${(p) => p.h}%;
  background: ${(p) => (p.muted ? p.color + '60' : p.color)};
  border-radius: 2px;
`

export const ChartFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
`

export const OpTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  thead th {
    text-align: left;
    font-size: 11px;
    letter-spacing: 0.08em;
    color: ${tokens.text.secondary};
    font-weight: 700;
    padding: 0.75rem 0.75rem;
    text-transform: uppercase;
    border-bottom: 1px solid ${tokens.border.hairline};
  }

  tbody td {
    padding: 0.85rem 0.75rem;
    border-bottom: 1px solid ${tokens.border.hairline};
    color: ${tokens.text.primary};
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  .op-cell {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: ${tokens.surface.base};
    border: 1px solid ${tokens.border.hairline};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${tokens.accent.base};
    font-size: 12px;
    font-weight: 700;
  }

  .incident {
    font-size: 11px;
    color: ${tokens.status.danger.fg};
    margin-top: 2px;
  }
`

export const SignalBox = styled.div`
  margin-top: 0.75rem;
  padding: 0.9rem 1rem;
  border-left: 3px solid ${tokens.status.success.fg};
  background: ${tokens.surface.base};
  border-radius: ${tokens.radius.chip};
  line-height: 1.5;

  .label {
    color: ${tokens.status.success.fg};
    font-weight: 700;
  }

  .hl-green {
    color: ${tokens.status.success.fg};
    font-weight: 700;
  }

  .hl-orange {
    color: ${tokens.accent.base};
    font-weight: 700;
  }
`

export const ScrollIndicator = styled.div`
  height: 4px;
  border-radius: 2px;
  background: ${tokens.surface.base};
  overflow: hidden;
  margin-top: 0.75rem;
`

export const ScrollFill = styled.div<{ w: number }>`
  width: ${(p) => p.w}%;
  height: 100%;
  background: ${tokens.accent.base};
`

export const StackedBar = styled.div`
  display: flex;
  height: 12px;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 1rem;
`

export const StackedSeg = styled.div<{ w: number; color: string }>`
  width: ${(p) => p.w}%;
  background: ${(p) => p.color};
`

export const LegendList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .li {
    display: grid;
    grid-template-columns: 1fr auto auto;
    gap: 0.75rem;
    align-items: center;
    font-size: 13px;
  }

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 2px;
  }

  .name {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${tokens.text.primary};
  }

  .pct {
    color: ${tokens.text.primary};
    font-weight: 700;
    min-width: 32px;
    text-align: right;
  }
`

export const BenchList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
`

export const BenchRow = styled.div<{ positive?: boolean }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  align-items: center;

  .v {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0.5rem;
    font-size: 13px;
    color: ${tokens.text.primary};
  }

  .num {
    font-weight: 700;
  }

  .delta {
    color: ${(p) => (p.positive ? tokens.status.success.fg : tokens.status.danger.fg)};
    font-weight: 700;
    font-size: 12px;
  }
`

export const FuelMetricsPanel = styled(Panel)`
  border: 1px solid ${tokens.accent.base};
`

export const FuelTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;

  .icon {
    width: 28px;
    height: 28px;
    border-radius: ${tokens.radius.chip};
    background: ${tokens.border.hairline};
    border: 1px solid ${tokens.border.hairline};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${tokens.accent.base};
  }

  .src {
    border: 1px solid ${tokens.accent.base};
    color: ${tokens.accent.base};
    padding: 3px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
  }
`

export const FuelMetricGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1rem;
`

export const FuelMetricItem = styled.div`
  .value {
    font-size: 22px;
    font-weight: 800;
    color: ${tokens.text.primary};
    margin-top: 6px;
  }

  .green {
    color: ${tokens.status.success.fg};
  }

  .orange {
    color: ${tokens.accent.base};
  }
`

export const BoundaryNote = styled.div`
  margin-top: 1rem;
  padding: 0.9rem 1rem;
  background: ${tokens.surface.base};
  border-radius: ${tokens.radius.chip};
  line-height: 1.5;

  .strong {
    color: ${tokens.text.primary};
    font-weight: 700;
  }
`

export const CostEfficiencyBox = styled.div`
  background: ${tokens.surface.base};
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  padding: 1rem 1.25rem;
  margin-top: 1rem;

  .ce-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 0.5rem 0;
  }

  .ce-v {
    color: ${tokens.status.success.fg};
    font-weight: 700;
  }
`

export const CostBarStacked = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0.5rem 0;

  .top {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
  }

  .amt {
    display: inline-flex;
    gap: 8px;
    color: ${tokens.text.primary};
    font-weight: 700;
    font-size: 14px;
  }

  .pct {
    color: ${tokens.text.secondary};
    font-weight: 500;
    font-size: 12px;
  }
`

export const CostTrack = styled.div`
  height: 6px;
  background: ${tokens.surface.base};
  border-radius: 3px;
  overflow: hidden;
`

export const CostFill = styled.div<{ w: number; color: string }>`
  width: ${(p) => p.w}%;
  height: 100%;
  background: ${(p) => p.color};
`
